import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Navigation from "@/components/Navigation";
import BackToTop from "@/components/BackToTop";
import HeroSection from "@/components/sections/HeroSection";
import ProblemSolutionSection from "@/components/sections/ProblemSolutionSection";
import ServicesSection from "@/components/sections/ServicesSection";
import ProcessSection from "@/components/sections/ProcessSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import LocalAuthoritySection from "@/components/sections/LocalAuthoritySection";
import ContactSection from "@/components/sections/ContactSection";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/sections/Footer";
import GallerySection from "@/components/sections/service-page/GallerySection";

const App = () => {
  const { t, i18n } = useTranslation('home');
  const isSpanish = i18n.language === 'es';
  const canonicalUrl = isSpanish ? 'https://altumcontractors.com/es' : 'https://altumcontractors.com/';

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
        <link rel="canonical" href={canonicalUrl} />
        {/* Alternate language links for SEO */}
        <link rel="alternate" hrefLang="en" href="https://altumcontractors.com/" />
        <link rel="alternate" hrefLang="es" href="https://altumcontractors.com/es" />
        <link rel="alternate" hrefLang="x-default" href="https://altumcontractors.com/" />
        <meta property="og:title" content={t('meta.title')} />
        <meta property="og:description" content={t('meta.description')} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={isSpanish ? 'es_US' : 'en_US'} />
        <meta property="og:image" content="https://altumcontractors.com/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Altum Contractors - Houston Roofing Experts" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('meta.title')} />
        <meta name="twitter:description" content={t('meta.description')} />
        <meta name="twitter:image" content="https://altumcontractors.com/og-image.jpg" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      </Helmet>
      <BackToTop />
      <div className="min-h-screen">
        <Navigation />
        <main>
          <HeroSection />
          <ContactSection />
          <ProblemSolutionSection />
          <ServicesSection />
          <ProcessSection />
          <TestimonialsSection />
          <GallerySection
            tagSlug="gallery"
            eyebrow={t('gallery.eyebrow')}
            headline={t('gallery.headline')}
            subheadline={t('gallery.subheadline')}
          />
          <LocalAuthoritySection />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default App;
